module.exports = __webpack_public_path__ + "static/img/coupon.ddd26b37.png";